// Thin wrapper around @voris/analytics so component code doesn't have to
// guard on the SDK being initialized (no-ops if REACT_APP_VORIS_WRITE_KEY
// wasn't set at build time).
import * as voris from '@voris/analytics';

const enabled = !!process.env.REACT_APP_VORIS_WRITE_KEY;

export function track(name, props) {
  if (!enabled) return;
  try {
    voris.track(name, props);
  } catch (_) {
    // Don't let analytics errors break the app
  }
}

export function identify(uid, traits) {
  if (!enabled) return;
  try {
    voris.identify(uid, traits);
  } catch (_) {}
}

export function page(name, props) {
  if (!enabled) return;
  try {
    voris.page(name, props);
  } catch (_) {}
}
